import React from 'react';
import s from '../Card.scss';
import { CisItem, ContentInstance } from '../../../models/apis/batchCisApi';
import { isFeedInstance } from '../../../models/feed';
import { LinkWrapper } from '../../../components/BaseComp';

interface Props {
    source: CisItem[],
}

const FirstTwo = (props: Props) => {
    const { source } = props;
    const datas = source.slice(0, 2);
    return (
        <div className={s.videoFirstTwo}>
            {
                datas.map((data, index) => {
                    const dataIns:ContentInstance = data as ContentInstance;
                    let imgUrl = dataIns.cover || (dataIns.images && dataIns.images[0]) || '';
                    imgUrl = imgUrl
                        .replace(/c_cut/g, 'c_lfill')
                        .replace(/w_([\s\S]+?),/g, 'w_396,')
                        .replace(/h_([\s\S]+?)(,|\/)/g, 'h_220$2');
                    return (
                        <LinkWrapper href={dataIns.url} className={s.item} key={dataIns.title + index}>
                            <div className={s.coverBox} >
                                <img src={imgUrl} className={s.cover} />
                                <i className={[s.videoIcon, 'bicon-play'].join(' ')} />
                            </div>
                            <p className={s.feedTitle}>{dataIns.title}</p>
                        </LinkWrapper>
                    );
                })
            }
        </div>
    );
};

export const VideoCard = (props: Props) => {
    const { source } = props;
    return (
        <div className={s.cardContainer} style={{ height: 355 }} data-spm="top-video">
            <div>
                <h3 className={s.title}><span>视频</span></h3>
            </div>
            <FirstTwo source={source} />
            {
                source.slice(-4).map((data, index) => isFeedInstance(data) ? (
                    <div key={data.title + index} className={s.feedTitle}>
                        <LinkWrapper href={data.url} >
                            <i className={['bicon-play', s.videoIcon].join(' ')}/>
                            {data.title}
                        </LinkWrapper>
                    </div>) : null,
                )
            }
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/HomeTop/VideoCard/index.tsx